import React, { Component } from "react";
import spinner from './../../Spinnerimage.gif'

export class RedirectPage extends Component {
  constructor(props) {
    super();
    
    this.state = { ...props, isLoaded: true };
    
  }
  componentDidMount() {
   window.location = this.props.location.state.loc;
  }
  render() {
    let isLoadervalue = this.state.isLoaded;
    if (isLoadervalue) {
      return (
        <div className="spinner">
           <img src={spinner} alt="spinner"/>
        </div>
        
      )
    }
    return (<section>Redirecting...</section>);
  }
}

export default RedirectPage;